import React from 'react'
import { Maybe } from 'graphql/jsutils/Maybe'
import moment from 'moment'
import { Typography } from 'transfix-ui/core'
import { FORMATS } from 'constants/datetime'
import { ValueField } from '../../../ValueField'

interface ITransfixFlagsListedAs {
  title: string
  updatedAt: Maybe<string>
  updatedBy: Maybe<string>
  value: boolean | undefined
}

export const TransfixFlagsListedAs = ({
  title,
  updatedAt,
  updatedBy,
  value,
}: ITransfixFlagsListedAs) => {
  return (
    <div>
      <ValueField title={`Transfix as ${title}`} value={value} />
      <Typography variant='body2' color='textSecondary'>
        {!!updatedBy && `Added by ${updatedBy} `}
        {!!updatedAt && `at ${moment(updatedAt).format(FORMATS.dateFormat)}`}
      </Typography>
    </div>
  )
}
